import { t } from "i18next";
import { Image } from "neetoicons";

export const getThumbnailAddon = command => ({
  label: t("neetoMolecules.documentEditor.thumbnailImage"),
  optionName: "thumbnail-image",
  command,
  icon: Image,
  isEnabled: true,
  "data-testid": "thumbnail-image-addon",
});
